import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import headOfficeAxios from 'src/utils/axiosHeadOffice'

export const getPaymentTypes = createAsyncThunk(
  '/getPaymentTypes',
  async () => {
    const response = await axios.get('/GetPaymentTypes');
    return response.data;
  }
);

export const getPaymentTypeDetails = createAsyncThunk(
  '/getPaymentTypeDetails',
  async (id) => {
    const response = await axios.get(`/GetPaymentTypeDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

export const getPaymentTypeTenant = createAsyncThunk(
  '/GetPaymentTypeTenant',
  async () => {
    const response = await headOfficeAxios.get('/GetPaymentTypeTenant');
    return response.data;
  }
);

export const setPaymentTypeTenant = createAsyncThunk(
  '/SetPaymentTypeTenant',
  async dto => {
    const response = await headOfficeAxios.post(`/SetPaymentTypeTenant`, dto);
    return response.data;
  }
);

const paymentTypeSlice = createSlice({
  name: 'paymentType',
  initialState: {
    loading: false,
    error: '',
    paymentTypes: [],
    paymentTypeDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: '',
    paymentTypeTenant: []
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },

    resetDescriptions(state) {
      state.paymentTypeDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    changePaymentTypeTenant(state, action) {
      state.paymentTypeTenant = action.payload
    }
  },

  extraReducers: {
    [getPaymentTypes.pending]: (state) => {
      state.loading = true;
    },
    [getPaymentTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPaymentTypes.fulfilled]: (state, action) => {
      state.paymentTypes = action.payload;
      state.loading = false;
    },
    [getPaymentTypeDetails.pending]: (state) => {
      state.loading = true;
    },
    [getPaymentTypeDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPaymentTypeDetails.fulfilled]: (state, action) => {
      state.paymentTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.paymentTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getPaymentTypeTenant.pending]: (state) => {
      state.loading = true;
    },
    [getPaymentTypeTenant.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPaymentTypeTenant.fulfilled]: (state, action) => {
      state.paymentTypeTenant = action.payload;
      state.loading = false;
    },
    [setPaymentTypeTenant.pending]: (state) => {
      state.loading = true;
    },
    [setPaymentTypeTenant.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setPaymentTypeTenant.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    }
  }
});

export const paymentTypeActions = paymentTypeSlice.actions;

export default paymentTypeSlice;
